export const REQUEST_FETCH: string = 'REQUEST_FETCH';
export const FETCH_FAILED: string = 'FETCH_FAILED';
export const MOVIE_GET_NOW_PLAYING: string = 'MOVIE_GET_NOW_PLAYING';
export const MOVIE_GET_MOVIE_DETAILS: string = 'MOVIE_GET_MOVIE_DETAILS';
export const MOVIE_GET_RECCOMENDATION: string = 'MOVIE_GET_RECCOMENDATION';
export const MOVIE_GET_CREDITS: string = 'MOVIE_GET_CREDITS';
export const PEOPLE_GET_DETAILS: string = 'PEOPLE_GET_DETAILS';
export const PEOPLE_GET_MOVIE_CREDITS: string = 'PEOPLE_GET_MOVIE_CREDITS';
export const PEOPLE_GET_SERIE_CREDITS: string = 'PEOPLE_GET_SERIES_CREDITS';
export const SEARCH_REQUESTED: string = 'SEARCH_REQUESTED';
export const SEARCH_RESULTS: string = 'SEARCH_RESULTS';
export const SEARCH_FAILED: string = 'SEARCH_FAILED';
export const SERIE_GET_TOP_RATED: string = 'SERIE_GET_TOP_RATED';
export const SERIE_GET_SERIE_DETAILS: string = 'SERIE_GET_SERIE_DETAILS';
export const SERIE_GET_RECCOMENDATION: string = 'SERIE_GET_RECCOMENDATION';
export const SERIE_GET_CREDITS: string = 'SERIE_GET_CREDITS';
export const HOME_GET_NOW_PLAYING: string = 'HOME_GET_NOW_PLAYING';
export const HOME_GET_TRAILER: string = 'HOME_GET_TRAILER';
export const HOME_GET_TRENDING_MOVIES: string = 'HOME_GET_TRENDING_MOVIES';
export const HOME_GET_TRENDING_SERIES: string = 'HOME_GET_TRENDING_SERIES';
export const AUTH_LOGIN_USER: string = 'AUTH_LOGIN_USER';
export const AUTH_LOGOUT_USER: string = 'AUTH_LOGOUT_USER';
export const FAVOURITE_REQUEST_INIT: string = 'FAVOURITE_REQUEST_INIT';
export const FAVOURITE_GET_FAVOURITES: string = 'FAVOURITE_GET_FAVOURITES';
export const FAVOURITE_GET_FAVOURITES_FAILED: string =
  'FAVOURITE_GET_FAVOURITES_FAILED';
